module.exports = __webpack_public_path__ + "img/Sibiu_c_kl.4649e7b9.jpg";